export class AzureSuggestsRequest {
  search: string;
  // Must match a suggester defined on the "suggestions" index. The index is created
  // with a single suggester named "HomeSuggester" (see Rubbl.Service.Inventory SuggestionsIndexer).
  suggesterName: string = "HomeSuggester";
  top: number = 4;
  select: string = "displayText, searchPriority, autoFacetFields, autoFacetValues";
  highlightPreTag: string = "<b class='text-grey'>";
  highlightPostTag: string = "</b>";
  fuzzy: boolean = true;
}
